'use client'

import { useEffect } from 'react'
import { analytics } from '@/lib/firebase'
import { logger } from '@/lib/logger'

export default function FirebaseAnalytics() {
  useEffect(() => {
    if (analytics) {
      logger.info('Firebase Analytics ready')
    }
  }, [])

  return null
}